import { component } from "preact";
import { css } from "emotion";

const Label = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  maxWidth,
  semiBold,
  inline = false,
  inlineMobile = false,
  verticalAlign,
  verticalAlignMobile,
  children
}) => {
  const styleObj = {
    fontSize: 14,
    fontWeight: semiBold ? 600 : 400,
    color,
    maxWidth: maxWidth ? maxWidth : "none",
    marginTop,
    marginBottom,
    marginRight,
    marginLeft,
    display: inline ? "inline" : "block",
    verticalAlign: verticalAlign ? verticalAlign : "initial"
  };

  styleObj[`@media(max-width:${breakpoint}px)`] = {
    fontSize: 12,
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile,
    display: inlineMobile ? "inline" : "block",
    verticalAlign: verticalAlignMobile ? verticalAlignMobile : "initial"
  };

  const style = css(styleObj);

  return <p className={style}>{children}</p>;
};

export default Label;
